import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactAzEnTortenetemContent from '@/components/contact/ContactAzEnTortenetemContent'

export default function ContactAzEnTortenetem() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - Az én történetem | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés Az én történetem programra" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/az-en-tortenetem" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat (Az én történetem) | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés &quot;Az én történetem&quot; képregényes művészetterápiás foglalkozásra"
          hidden="az-en-tortenetem"
          content={<ContactAzEnTortenetemContent />}
        >
          <img
            src={`${config.basePath}/images/az-en-tortenetem.jpg`}
            alt="Az én történetem"
            width={"100%"}
          />
        </Contact>
      </section>
      
      <div className="mx-auto w-3/4 mb-8">
        <p>
          <strong>Adatkezelési tájékoztatás:</strong> Az űrlap kitöltésével hozzájárulsz adataid kommunikáció és kapcsolattartás céljára történő kezeléséhez. Az Európai Parlament és Tanács (EU) 2016/679. rendelete (továbbiakban: GDPR) a személyes adatok kezelésére vonatkozó rendelete az irányadó az adatok kezelésében.
        </p>
      </div>
    </>
  )
}
